
/**
 * 콘텐츠 타입
 */
export type GetCourseDraftById200LocalizedSectionsItemLecturesItemContentType = typeof GetCourseDraftById200LocalizedSectionsItemLecturesItemContentType[keyof typeof GetCourseDraftById200LocalizedSectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCourseDraftById200LocalizedSectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  INTERACTIVE: 'INTERACTIVE',
  QUIZ: 'QUIZ',
} as const;
